var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 15.875 15.875",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 7.938A7.937 7.937 0 110 7.938a7.937 7.937 0 0115.875 0",
    fill: "#cfd2d3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 9.719h.003zm-5.787-.205l2.716 1.556 2.717-1.556V6.361L7.83 4.805 5.113 6.361zm2.716 2.315a.355.355 0 01-.175-.046l-3.07-1.758a.353.353 0 01-.177-.306V6.156c0-.126.067-.243.178-.306l3.07-1.757a.353.353 0 01.35 0l3.07 1.757c.11.063.177.18.177.306v3.563a.353.353 0 01-.178.306l-3.07 1.758a.356.356 0 01-.175.046",
    fill: "#6c6d71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63 6.076l-.8-.458L5.817 6.77v2.335l1.436.822z",
    fill: "#fdfeff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.013 10.603l-1.9-1.089V6.361l2.716-1.556 1.042.596.24-.675-1.106-.634a.353.353 0 00-.35 0L4.584 5.85a.354.354 0 00-.178.306V9.72c0 .127.068.243.177.306l2.188 1.252z",
    fill: "#fdfeff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.938.706C3.95.706.705 3.95.705 7.938c0 .906.175 1.771.48 2.572l1.236.186a6.129 6.129 0 01-.658-2.758 6.18 6.18 0 016.173-6.174c1.964 0 3.713.925 4.844 2.359l.224-1.337A7.206 7.206 0 007.938.706",
    fill: "#fdfeff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 3.212c-.08.623-.211 1.533-.358 2.135-.243.992-.948 2.138-.948 2.138l-.136.083v2.15c0 .38-.204.731-.533.92l-3.07 1.757a1.06 1.06 0 01-1.05 0L5.27 11.231l-3.927-.339c1.133 2.517 3.66 4.278 6.595 4.278 3.987 0 7.232-3.245 7.232-7.232 0-1.807-.671-3.457-1.77-4.726",
    fill: "#6c6d71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSilver);
export default __webpack_public_path__ + "static/media/icon-silver.0082cb60de8af859d3635b17126c264d.svg";
export { ForwardRef as ReactComponent };